import { OfferStatus } from '@/api/v2/requests/offers';

export const OFFER_STATUS_MAP = {
  ACTIVE: 'active',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  FINISHED: 'finished',
  ACCEPTED: 'accepted',
  DRAFT: 'draft',
  CONTRACT: 'contract',
  PENDING_APPROVAL: 'pending_approval',
  RESERVED: 'reserved',
  PENDING_CONTRACT_APPROVAL: 'pending_contract_approval',
  CONTRACT_APPROVED: 'contract_approved',
  ARCHIVED: 'archived',
};

export const OFFER_STATUS_COLORS = {
  [OfferStatus.ACTIVE]: 'bg-green',
  [OfferStatus.APPROVED]: 'bg-primary-light',
  [OfferStatus.REJECTED]: 'bg-red',
  [OfferStatus.CONTRACT]: 'bg-red',
  [OfferStatus.FINISHED]: 'bg-blue-dark',
  [OfferStatus.PENDING_APPROVAL]: 'bg-orange',
  [OfferStatus.RESERVED]: 'bg-blue',
  [OfferStatus.PENDING_CONTRACT_APPROVAL]: 'bg-yellow-dark',
  [OfferStatus.CONTRACT_APPROVED]: 'bg-blue-dark',
  [OfferStatus.DRAFT]: 'bg-gray',
  [OfferStatus.ARCHIVED]: 'bg-gray-dark',
};
